import checkIcon from 'assets/icons/check.svg';
import FaceImage from 'assets/icons/facematch.svg';
import alertImage from 'assets/img/alert.svg';
import { useState } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { getStorePermissions } from 'v3/data/store/stores/actions';
import {
  AlignButtons,
  ContentStyled,
} from 'v3/pages/Contracting/Details/Cards/ContractInformation/Steps/AssignContract/styles';
import { BoxGroupStyled } from 'v3/pages/Contracting/Details/Cards/styles';
import { IAssignContractProps } from 'v3/pages/Contracting/Details/Cards/types';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { ConfirmationModal } from 'v3/shared/components/Modal/ConfirmationModal';
import { SellerCodeModal } from 'v3/shared/components/Modal/SellerCodeModal';
import { ContractSignatureToast } from 'v3/shared/components/Toast/ContractSignatureToast';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';

export const AssignContract = ({ handleContractSignature, sellerFeatureEnabled }: IAssignContractProps) => {
  const { currentStep } = useStoreSelector((store) => store.navigate);
  const { contractingReadOnly } = getStorePermissions();
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const isContractAssigned = currentStep === ContractNavigationEnum.CONTRACT_COMPLETED;

  const handleConfirmAndClose = () => {
    handleContractSignature();
    setConfirmationModalOpen(false);
  };

  return (
    <ContentStyled>
      {!isContractAssigned ? (
        <>
          {!contractingReadOnly && (
            <AlignButtons>
              <FlexButton text="Assinar contrato" handleClick={() => setConfirmationModalOpen(true)} size="small" />
            </AlignButtons>
          )}
        </>
      ) : (
        <BoxGroupStyled>
          <img src={checkIcon} alt="Success" />
          <BodyLarge>Contrato assinado!</BodyLarge>
          <SubtitleLarge>Agora você pode entregar o smartphone para o cliente</SubtitleLarge>
          <ContractSignatureToast />
        </BoxGroupStyled>
      )}

      {sellerFeatureEnabled ? (
        <SellerCodeModal
          modal={{
            active: confirmationModalOpen,
            title: 'Consultor, informe seu CPF para assinar o contrato',
            subtitle:
              'Ao confirmar a assinatura do contrato, você estará realizando uma ação definitiva e irreversível.',
            image: FaceImage,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Assinar contrato',
          }}
          onClose={() => setConfirmationModalOpen(false)}
          onConfirm={handleConfirmAndClose}
        />
      ) : (
        <ConfirmationModal
          modal={{
            active: confirmationModalOpen,
            title: 'Deseja assinar o contrato?',
            subtitle:
              'Ao confirmar a assinatura do contrato, você estará realizando uma ação definitiva e irreversível.',
            image: alertImage,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Assinar contrato',
          }}
          onClose={() => setConfirmationModalOpen(false)}
          onConfirm={handleConfirmAndClose}
        />
      )}
    </ContentStyled>
  );
};
